import { createApiRef } from '@backstage/core-plugin-api';
import { EpDevPPluginIds } from '@solace-labs/backstage-plugin-ep-devp-common';
import { IEpDevPConsumerProductsApiClient } from '@solace-labs/backstage-plugin-ep-devp-consumer-products-common';
import { IEpDevPManageAppsApiClient } from '@solace-labs/backstage-plugin-ep-devp-manage-apps-common';


export const epDevPManageAppsApiRef = createApiRef<IEpDevPManageAppsApiClient>({
  id: `${EpDevPPluginIds.EpDevPManageAppsPluginId}.api-ref`
});

export const epDevPConsumerProductsApiRef = createApiRef<IEpDevPConsumerProductsApiClient>({
  id: `${EpDevPPluginIds.EpDevPManageAppsPluginId}.${EpDevPPluginIds.EpDevPConsumerProductsPluginId}.api-ref`
});